import { Features } from 'APP/packages/features/Features';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export const checkStarsFeedback = (channelId: string): void => {
  if (!Features.isSendFeedbackEnabled()) {
    return;
  }
  const dontShowFeedback = storage.feedback.getDontShowValue();
  const feedbackSkipCounter = storage.feedback.getSkipValue();

  if (!channelId || dontShowFeedback) {
    return;
  }

  if (!feedbackSkipCounter) {
    Entities.feedback.setChannelId(channelId);
    Entities.feedback.setIsStarsShown(true);

    return;
  } else {
    storage.feedback.increaseSkipValue();
  }
};
